module.exports = __webpack_public_path__ + "img/woman.de959308.png";